import "./App.css";
import AppRoutes from "./router/appRoutes";

function App(props) {
  return (
    <div className="App">
      <AppRoutes />
    
    </div>
  );
}

export default App;
